<div class="header container-fluid p-0">
  <header>
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark p-0">
      <div class="container-fluid">
        <a class="navbar-brand p-0 position-absolute top-0" style="height: 100%;">
          <!-- <img src="../../../../assets/images/public/BUDefaultLogo.jpeg" height="125" width="125" class="logo"
          *ngIf="!accountDetails?.logo"> -->
          @if (accountDetails?.account?.logo) {
            <img src="{{accountDetails?.account?.logo}}" height="125" width="125" class="img-ratio "
              >
          }
        </a>
        <span class="nav-item text-light home-link cursor">
          <a class="nav-link  d-flex align-items-center" aria-current="page" (click)="gotoOverViewPage()"
            style="border:1px solid gray">
            <img src="../../../../assets/images/uploads/home.svg" class="me-1">&nbsp;Home </a>
          </span>

          <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
            aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ms-auto mb-2 mb-lg-0  d-flex align-items-center">
              <!-- <li class="nav-item"><a class="nav-link active" aria-current="page" href="#">Home</a></li> -->
              <li class="nav-item me-1 cursor">
                <a class="nav-link rounded-10 header-icon" (click)="goToHome()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-bell" viewBox="0 0 16 16">
                    <path
                      d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z" />
                  </svg>
                </a>
              </li>
              <li class="nav-item me-1 cursor">
                <a class="nav-link rounded-10 header-icon" (click)="goToUserSettings()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-gear" viewBox="0 0 16 16">
                    <path
                      d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z" />
                    <path
                      d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z" />
                  </svg>
                </a>
              </li>
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown"
                aria-expanded="false"> {{accountDetails?.user?.name}} </a>
                <ul class="dropdown-menu p-0 overflow-hidden">
                  <li class="cursor">
                    <a class="dropdown-item px-4 py-2" (click)="goToUserProfile()">View Profile</a>
                  </li>
                  <li>
                    <hr class="dropdown-divider m-0">
                  </li>
                  <li>
                    <a class="dropdown-item px-4 py-2" href="javascript:void(0)" (click)="logout()">
                      Log Out
                    </a>
                  </li>
                </ul>
              </li>
              <li class="nav-item">
                <a class="nav-link">
                  <img [src]="avatar" height="44" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
    <section class="sub-header d-flex justify-content-between align-items-center">

    </section>
  </div>
  <div class="header container-fluid p-0 text-center h1 m-5">
    <p>You do not have the permissions to view this page.</p>
  </div>